import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface ActionButtonProps {
  onClick?: () => void;
  className?: string;
  width?: string;
  children: ReactNode;
  disabled?: boolean;
}

/**
 * A reusable action button component that can be used across the application
 *
 * @param onClick - Function to execute when button is clicked
 * @param className - CSS class for styling
 * @param width - Width of the button (default: "auto")
 * @param children - Button content
 * @param disabled - Whether the button is disabled
 */
const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  className,
  width = "auto",
  children,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        width,
        opacity: disabled ? 0.7 : 1,
      }}
      className={className}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

/**
 * A container for grouping multiple action buttons
 */
export const ActionButtonGroup: React.FC<{
  children: ReactNode;
  gap?: number;
}> = ({ children, gap = 2 }) => {
  return (
    <Box sx={{ display: "flex", gap, justifyContent: "flex-end" }}>
      {children}
    </Box>
  );
};

export default ActionButton;
